import { Entity } from '@data-client/rest';
class UserStatusEntity extends Entity {
    constructor() {
        super(...arguments);
        this.isDefault = false;
        this.title = '';
        this.userStatusId = 0;
    }
    pk() {
        return this.userStatusId.toString();
    }
}
UserStatusEntity.key = 'UserStatus';
export { UserStatusEntity };
